import { Languages } from "../../types"
import { DashboardDescriptions } from "./types"

const DescriptionsEnUs: DashboardDescriptions = {
    COMPANY_INFORMATION: {
        TITLE: "Company Information",
        NAME: "Name",
        ADDRESS: "Address",
        PHONE: "Phone",
        SLOGAN: "Slogan",
        EMAIL: "Email",
    },
    STATISTICS: {
        TITLE: "Statistics",
        ACCOUNT_RECEIVABLES: {
            TITLE: 'Account Receivables',
            SECONDARY: 'received',
            TEXT: 'Total to receive in selected range.',
        },
        ACCOUNT_PAYABLES: {
            TITLE: 'Account Payables',
            SECONDARY: 'payed',
            TEXT: 'Total to pay in selected range.',
        },
        SERVICE_CONTRACTS: {
            TITLE: 'Customer Contracts',
            SECONDARY: 'active contracts',
            TEXT: 'Recurrent contracts total.',
        },
        PAYABLE_CONTRACTS: {
            TITLE: 'Payable Contracts',
            SECONDARY: 'active contracts',
            TEXT: 'Recurrent contracts total.',
        },
        EXPENDITURE_RECORDS: {
            TITLE: 'Expenditure Records',
            SECONDARY: '',
            TEXT: 'Total expenses in the current lapse.',
        },
        CASHBOX_BALANCE: {
            TITLE: 'Cashbox Balance',
            SECONDARY: '',
            TEXT: 'Current cashbox balance.',
        },
        ACCOUNT_RECEIVABLES_TOTAL: {
            TITLE: 'Total Account Receivables',
            SECONDARY: 'received',
            TEXT: 'Current Total to receive.',
        },
        ACCOUNT_PAYABLES_TOTAL: {
            TITLE: 'Total Account Payables',
            SECONDARY: 'payed',
            TEXT: 'Current Total to pay.',
        },
    },
    SERVICE_DISTRIBUTION: {
        TITLE: "Customer Contracts Distribution",
        DETAIL_LABEL: "Total Amount",
    },
    FUTURE_PAYABLES: {
        TITLE: "Future Payments",
    },
    GENERAL_BALANCE: {
        TITLE: "General Balance",
        INCOMES: "Incomes",
        ACCOUNTS_RECEIVED: "Accounts received",
        OUTCOMES: "Outcomes",
        ACCOUNTS_PAYED: "Accounts payed",
        EXPENDITURES: "Expenditures",
    },
    SHORTCUTS: {
        TITLE: "Shortcuts",
        ACCOUNT_RECEIVABLES: "Account Receivables",
        ACCOUNT_PAYABLES: "Account Payables",
        CREATE_EXPENDITURE_RECORD: "Create Expenditure Record",
        CREATE_SERVICE_CONTRACT: "Create Service Contract",
        SERVICE_CONTRACTS: "Service Contracts",
        PAYABLE_CONTRACTS: "Payable Contracts",
    },
}

const DescriptionsEsUs: DashboardDescriptions = {
    COMPANY_INFORMATION: {
        TITLE: "Información",
        NAME: "Nombre",
        ADDRESS: "Dirección",
        PHONE: "Teléfono",
        SLOGAN: "Slogan",
        EMAIL: "Correo",
    },
    STATISTICS: {
        TITLE: "Estadísticas",
        ACCOUNT_RECEIVABLES: {
            TITLE: 'Cuentas por Cobrar',
            SECONDARY: 'cobrado',
            TEXT: 'Total a cobrar en el rango seleccionado.',
        },
        ACCOUNT_PAYABLES: {
            TITLE: 'Cuentas por Pagar',
            SECONDARY: 'pagado',
            TEXT: 'Total a pagar en el rango seleccionado.',
        },
        SERVICE_CONTRACTS: {
            TITLE: 'Contratos de Clientes',
            SECONDARY: 'contratos activos',
            TEXT: 'Total de contratos recurrentes mensuales.',
        },
        PAYABLE_CONTRACTS: {
            TITLE: 'Contratos de Pago',
            SECONDARY: 'contratos activos',
            TEXT: 'Total de contratos recurrentes mensuales.',
        },
        EXPENDITURE_RECORDS: {
            TITLE: 'Total de Gastos',
            SECONDARY: '',
            TEXT: 'Total de gastos en el rango seleccionado.',
        },
        CASHBOX_BALANCE: {
            TITLE: 'Saldo en caja',
            SECONDARY: '',
            TEXT: 'Actual saldo en caja.',
        },
        ACCOUNT_RECEIVABLES_TOTAL: {
            TITLE: 'Total Cuentas por Cobrar',
            SECONDARY: 'cobrado',
            TEXT: 'Total a cobrar actualmente.',
        },
        ACCOUNT_PAYABLES_TOTAL: {
            TITLE: 'Total Cuentas por Pagar',
            SECONDARY: 'pagado',
            TEXT: 'Total a pagar actualmente.',
        },
    },
    SERVICE_DISTRIBUTION: {
        TITLE: "Distribución de Contratos de Clientes",
        DETAIL_LABEL: "Monto Total",
    },
    FUTURE_PAYABLES: {
        TITLE: "Futuros Pagos",
    },
    GENERAL_BALANCE: {
        TITLE: "Balance General",
        INCOMES: "Ingresos",
        ACCOUNTS_RECEIVED: "Cuentas cobradas",
        OUTCOMES: "Salidas",
        ACCOUNTS_PAYED: "Cuentas pagadas",
        EXPENDITURES: "Gastos",
    },
    SHORTCUTS: {
        TITLE: "Accesos Directos",
        ACCOUNT_RECEIVABLES: "Cuentas por Cobrar",
        ACCOUNT_PAYABLES: "Cuentas por Pagar",
        CREATE_EXPENDITURE_RECORD: "Crear Registro de Gasto",
        CREATE_SERVICE_CONTRACT: "Crear Contrato de Servicios",
        SERVICE_CONTRACTS: "Contratos con Clientes",
        PAYABLE_CONTRACTS: "Contratos de Proveedores",
    },
}

const dashboardDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}

export const getDashboardDescriptions = (systemLang: Languages): DashboardDescriptions => (
    dashboardDictionary[systemLang]
)